// https://segmentfault.com/a/1190000009733948
import IframeDialog from './IframeDialog.vue'

var Iframe = {} // 定义插件对象
Iframe.install = function (Vue, options) { // vue的install方法，用于定义vue插件
  //
  console.log('install')
  const IframeController = Vue.extend(IframeDialog)
  let instance = null
  // 在Vue原型实现toast的DOM挂载、以及功能实现
  // 用户可以在Vue实例（Vue单文件就是一个Vue实例）通过this.$iframe来访问以下内容
  Vue.prototype.$iframe = {
    show: function (iframeUrl, iframeTitle) {
      if (!instance) {
        instance = new IframeController().$mount(document.createElement('div'))
        // 将toast的DOM挂载到body上
        document.body.appendChild(instance.$el)
      }

      document.getElementById('go-iframe-dialog-container').innerHTML = ''
      let iframe = document.createElement('iframe')
      iframe.setAttribute('src', iframeUrl)
      iframe.setAttribute('class', 'go-iframe-dialog-inner-iframe')
      document.getElementById('go-iframe-dialog-container').appendChild(iframe)

      instance.iframeShow = true
      instance.iframeTitle = iframeTitle
      return instance
    },
    close: function () {
      if (instance) {
        instance.iframeShow = false
        document.getElementById('go-iframe-dialog-container').innerHTML = ''
        // instance.iframeUrl = ''
        instance.iframeTitle = ''
      }
    }
  }
}
export default Iframe
// 导出Iframe（注意：此处不能用module exports导出，在一个文件中，不能同时使用require方式引入，而用module exports导出，两种方式不能混用）



// WEBPACK FOOTER //
// ./src/components/IframeDialog.js